export default __webpack_public_path__ + "ad5af5e5e941072111ab6acccc276d6c.png";